(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-himba-video-card"] && !Shopify.designMode) return;
  try {
    function setupHimbaVideos(root){
root.querySelectorAll('.sf-himba-video-frame').forEach(frame=>{
if(frame.dataset.ready)return;
frame.dataset.ready='true';
const video=frame.querySelector('video');const button=frame.querySelector('button');
const update=()=>{button.textContent=video.paused?'Lire':'Pause';button.setAttribute('aria-pressed',String(!video.paused));};
video.muted=true;
button.addEventListener('click',()=>{video.muted=true;if(video.paused){video.play().catch(()=>{});}else{video.pause();}});
video.addEventListener('play',update);video.addEventListener('pause',update);
if('IntersectionObserver' in window){new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){video.play().catch(()=>{});}else{video.pause();}}),{threshold:.3}).observe(video);}
});
}
setupHimbaVideos(document);
document.addEventListener('shopify:section:load',event=>setupHimbaVideos(event.target));
  } catch(e) { console.error(e); }
})();

})();
